var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"self_media_header"}},[_c('div',{staticClass:"preface"},[_c('img',{attrs:{"src":require('@/assets/images/selfMedia/bg02.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }